/**
 * Any origin works as the base here: the question is only whether the value
 * resolves to somewhere else, and a placeholder keeps the check independent of
 * the page — and testable outside a browser.
 */
const RESOLUTION_BASE = 'https://return-to.invalid';

/**
 * Where /login sends a staff member once they are signed in. Only a path on this
 * origin is ever honoured — this value travels in a query string an untrusted
 * party can set. Resolving it and comparing the origin is the only reliable test:
 * prefix matching misses `/\evil.example`, which the URL parser normalises to
 * `//evil.example` and so resolves off-origin.
 */
export function safeReturnTo(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/')) return undefined;
  let resolved: URL;
  try {
    resolved = new URL(value, RESOLUTION_BASE);
  } catch {
    return undefined;
  }
  if (resolved.origin !== RESOLUTION_BASE) return undefined;
  return `${resolved.pathname}${resolved.search}${resolved.hash}`;
}

export function currentReturnTo(): string {
  return `${window.location.pathname}${window.location.search}`;
}
